// Global filters

import Vue from 'vue';

import { formatTime, formatTimeNoTZ, timeDifference, formatDiff, getEndTime } from './time';
import { fileSize } from './number';

Vue.filter('formatTime', formatTime);
Vue.filter('formatTimeNoTZ', formatTimeNoTZ);
Vue.filter('timeDifference', timeDifference);
Vue.filter('formatDiff', formatDiff);
Vue.filter('getEndTime', getEndTime);
Vue.filter('fileSize', fileSize);



// WEBPACK FOOTER //
// ./src/filters/index.js